import * as React from 'react';
import { IMenuProps } from './menu-props.interface';
import styled from 'styled-components';
import { LinkOriginEnum } from '../../../enum/link-origin.enum';
import { getLinkFinalURL } from '../../../util/url/get-link-final-url';
import { NormalRouteWrapper } from './atoms';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import {
  MENU_ITEM_VERTICAL_MARGIN,
  NORMAL_ROUTE_WRAPPER_HEIGHT
} from './consts';
import { addOpacity } from '../../../util/style/add-opacity.util';
import { IMainMenuItem } from '../../../interface/main-menu-item.interface';
import { MenuArrowDownIcon } from '../../icons';
import { Ellipsis } from '../../ellipsis';
import { observable, action } from 'mobx';
import { DropdownMenu } from './dropdown-menu';
import { lightenColor } from '../../../util/style/lighten-color.util';
import { getHexColorBrightness } from '../../../util/style/get-hex-color-brightness.util';

interface IMenuWrapperProps {
  backgroundColor: string;
  logoAlignment: 'left' | 'right' | 'center';
}

const MenuWrapper = styled.div`
  display: flex;
  width: 100%;
  flex: 1 1 100%;
  justify-content: ${(props: IMenuWrapperProps) => props.logoAlignment === 'left' ? 'flex-end' : 'flex-start'};
  background: ${(props: IMenuWrapperProps) => props.backgroundColor};
`;

interface IMenuItemProps extends Pick<IMenuProps, Exclude<keyof IMenuProps, 'items'>> {
  item: IMainMenuItem;
}

@observer
class MenuItem extends React.Component<IMenuItemProps & IInjectedProps> {
  @observable dropdownVisible: boolean = false;

  @action
  showMenu = () => this.dropdownVisible = true

  @action
  closeMenu = () => this.dropdownVisible = false

  render() {
    const {item} = this.props;
    let hoverTextColor;
    let textColor = this.props.textColor;
    if (this.props.textColor === this.props.state.colors.White) {
      hoverTextColor = lightenColor(textColor, -0.10);
    } else {
      hoverTextColor = lightenColor(textColor, 0.10);
    }
    if (getHexColorBrightness(hoverTextColor) < getHexColorBrightness(textColor)) {
      const temp = textColor;
      textColor = hoverTextColor;
      hoverTextColor = temp;
    }
    return <NormalRouteWrapper
      key={item.id}
      color={textColor}
      opacity={this.props.backgroundOpacity}
      hoverColor={hoverTextColor}
      isSelected={this.dropdownVisible || this.props.state.activeDesign.page && item.link && item.link.origin === LinkOriginEnum.Internal && item.link.pageId === this.props.state.activeDesign.page.id}
      to={item.subItems && item.subItems.length > 0 ? undefined : getLinkFinalURL(this.props.state, item.link)}
      onMouseEnter={this.showMenu}
      onMouseLeave={this.closeMenu}
    >
      <Ellipsis style={{flex: '1 1 100%', display: 'block', textAlign: 'center'}}>
        {item.label}
      </Ellipsis>
      {item.subItems && item.subItems.length > 0 && <MenuArrowDownIcon style={{marginRight: 5}} />}
      {this.dropdownVisible && <DropdownMenu onCloseMenu={this.closeMenu} left={0} top={NORMAL_ROUTE_WRAPPER_HEIGHT + MENU_ITEM_VERTICAL_MARGIN * 2} items={item.subItems} backgroundColor={this.props.backgroundColor} backgroundOpacity={this.props.backgroundOpacity} textColor={textColor} hoverTextColor={hoverTextColor} inEditor={this.props.inEditor} submenuDirection={this.props.logoAlignment === 'left' ? -1 : 1} menuStyle={this.props.menuStyle} />}
    </NormalRouteWrapper>;
  }
}

@inject('state')
@observer
export class DesktopMenu extends React.Component<IMenuProps & IInjectedProps> {
  render() {
    const {items} = this.props;
    return <MenuWrapper logoAlignment={this.props.logoAlignment} backgroundColor={addOpacity(this.props.backgroundColor, this.props.backgroundOpacity)}>
        {items.map(item => (
          <MenuItem key={item.id} {...this.props} item={item}/>
        ))}
      </MenuWrapper>;
  }
}